import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import SectionWithArrows from 'components/organisms/SectionWithArrows/SectionWithArrows';

const useStyles = makeStyles((theme) => ({
  root: {},
  pagination: {
    marginTop: theme.spacing(8),
    display: 'flex',
    justifyContent: 'center',
  },
  filterContainer: {
    marginBottom: theme.spacing(4),
  },
  content: {
    paddingTop: theme.spacing(2),
  },
  reportSelected: {
    backgroundColor: '#ECEBEB9D',
  },
  centerAlign: {
    textAlign: 'center',
  },
  commonTextSize: {
    fontSize: '17px',
  },
  secondTextSize: {
    fontSize: '20px',
  },
  titleTextSize: {
    fontSize: '22px',
    fontWeight: 'bold',
  },
  margins: {
    marginBottom: '10px',
  },
  bold: {
    fontWeight: 'bold',
  },
}));

const TermsAndConditions = (props) => {
  const { className, ...rest } = props; // eslint-disable-line no-unused-vars
  const classes = useStyles();

  return (
    <div
      className={clsx(className)}
      style={{
        textAlign: 'justify',
        marginTop: '20px'
      }}
    >
      <SectionWithArrows propClasses={{ section: classes.content }}>
        <div className={clsx(classes.centerAlign, classes.secondTextSize, classes.margins)}>Termat e përdorimit</div>
        <div className={clsx(classes.commonTextSize, classes.margins)}>
          Termat e përdorimit janë përditësuar në datën 22/12/2022 dhe janë efektive që nga data 22/12/2022.
        </div>

        <div className={clsx(classes.centerAlign, classes.secondTextSize, classes.margins)}>Pranimi i termave</div>
        <div className={clsx(classes.commonTextSize, classes.margins)}>
          JU LUTEMI LEXONI ME KUJDES DHE TËRËSISHT TERMAT E PËRDORIMIT. Termat e kushteve dhe të përdorimit janë një
          marrëveshje ligjore mes përdoruesve të platformës dhe Financave të Vetëqeverisjes Vendore. Këto terma të
          përdorimit janë të sanksionuara mbështetur mbi të drejtat dhe detyrimet ligjore në fuqi në Republikën e
          Shqipërisë e direktivat e BE dhe respektojnë marrëdhënjen mes përdoruesve dhe portalit Financat e
          Vetëqeverisjes Vendore. Në këtë mënyrë termat e mëposhtëm të përdorimit përfshinë të gjithë përdoruesit e
          platformës pa dallim.
        </div>
        <br />
        <div className={clsx(classes.secondTextSize, classes.margins, classes.bold)}>1. Liçencsa e përdorimit</div>
        <div className={clsx(classes.commonTextSize, classes.margins)}>
          Kjo platformë është një ide autentike e themeluesve dhe nuk mund të kopjohet, përvetësohet apo ndryshohet por
          vetëm të përdoret bazuar mbi termat e përdorimit. Çdo person i cili nuk zbaton termat e mësipërme të
          zhvillimit të aktivitetit është objekt i ligjeve të fuqi mbi të drejtën e autorit dhe krimit kumpjuterik.
        </div>

        <br />
        <div className={clsx(classes.secondTextSize, classes.margins, classes.bold)}>
          2. Kriteret ligjore të përdorimit
        </div>
        <div className={clsx(classes.commonTextSize, classes.margins)}>
          Përdorimi i informacioni të paraqitur nga Financat e Vetëqeverisje Vendore është i vlefshëm vetëm për të
          gjithë individët të cilët kanë interes në drejtim të përftimit të informacionit profesional mbi financave
          vendore në Republikën e Shqipërisë. Çdo veprim do të kryhet në përputhje me rregullat dhe legjislacionit në
          Republikën e Shqipërisë dhe direkativën e Bashkimit Europian WCAG 2.1 Level AA1.
        </div>

        <br />
        <div className={clsx(classes.secondTextSize, classes.margins, classes.bold)}>
          3. Ndalimet e dërgimit të mesazheve
        </div>
        <div className={clsx(classes.commonTextSize, classes.margins)}>
          Ne nuk do të dërgojmë asnjëherë mesazhe me përmbjeje:
          <ul style={{ marginLeft: '30px' }}>
            <li>Oferta për të berë transferta kombëtare apo ndërkombëtare të parave;</li>
            <li>Reklama të ndryshme, për shkak se nuk përbëjnë pjesë në aktivitetin e saj;</li>
            <li>Kërkesa për informacione konfidenciale të përdoruesve.</li>
          </ul>
        </div>

        <br />
        <div className={clsx(classes.secondTextSize, classes.margins, classes.bold)}>4. Jo Diskriminimit</div>
        <div className={clsx(classes.commonTextSize, classes.margins)}>
          Mbështetur në konvenatat ndërkombëtare kundër diskriminimit Financat e Vetëqeverisjes Vendore angazhohet të
          përjashtojë veprimet diskriminuese në bazë rrace, ngjyre, besimi, seksi, kombësie, moshe apo kufizimeve
          shëndetësore. Financat e Vetëqeverisjes Vendore ka të drejtën ligjore që në çdo informacion të publikuar ti
          nënshtrohet një kontrolli të rreptë mbi të drejtat e autorit dhe merr përsipër mbrojtjen e pronësisë
          intelektuale të informacionit të paraqitur.
        </div>

        <br />
        <div className={clsx(classes.secondTextSize, classes.margins, classes.bold)}>
          5. Ndalimi në respekt të shërbimeve
        </div>
        <div className={clsx(classes.commonTextSize, classes.margins)}>
          Në respekt të shërbimeve ndalohet:
          <ul style={{ marginLeft: '30px' }}>
            <li>
              Thyerja e ligjeve, të drejtës së autorit, të dhënave personale dhe të gjitha dispozitave të termave të
              përdorimit;
            </li>
            <li>Mashtrimi me me informacionin e siguruar nga shërbimi;</li>
            <li>Mashtrimi me cilësinë e shërbimeve dhe deklarimin e pavërtetë të informacionit;</li>
          </ul>
        </div>

        <div className={clsx(classes.commonTextSize)}>
          Termat e përdorimit sëbashku me deklartaën e privatësisë dhe të gjitha ligjet e tjera në fuqi të cilat janë
          pubikuar nga Financat e Vetëqeverisjes Vendore dhe kanë fuqi në territorin Republikës së Shqipërisë. Këto
          terma përdorimi janë të detyrueshme për tu zbatuar në madhërrënien e krijuar mes përdoruesve dhe
          administratorëve të Financave të Vetëqeverisjes Vendore (www.fvv.al).
        </div>
        <br />
        <div className={clsx(classes.commonTextSize)}>
          © 2022 Ministry of Finance and Economuy Private Limited. All Rights Reserved
        </div>
      </SectionWithArrows>
    </div>
  );
};

TermsAndConditions.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default TermsAndConditions;
